// extracted by mini-css-extract-plugin
export default {"hideTooltip":"y9-z","fadeIn":"z9-z","delay":"A9-z","recommendedSizeTooltip":"B9-z"};